
            const data = {"name":"google","data":{"viewBox":"0 0 60 60","data":"<path pid=\"0\" d=\"M30 24.2v11.6h16.41A17.4 17.4 0 1130 12.6a17.11 17.11 0 0111.27 4.2l7.62-8.75A29 29 0 1059 30v-5.8z\" _fill=\"#171614\"/>","originalColors":[{"type":"fill","color":"#171614"}],"stopColors":[]}}
        
                module.exports = data
                